/**
 * The Color — Form spam protection
 * Honeypot field, minimum fill time and a JS-presence token on every form
 * marked with [data-tc-protected].
 *
 * 2026-09-29 (audit S10/T12): removed the browser-string bot screening, the
 * per-session submission cap and the gtag "blocked" event. They gave no real
 * protection (a bot simply skips this script), the cap could stop a genuine
 * customer re-sending the contact form, and the event was reaching Google
 * Ads and Merchant Center. Real protection can only happen server-side; this
 * file just filters the laziest form-fillers.
 * (window.TheColor.Security had no callers and went with them.)
 */

(function () {
  'use strict';

  var MIN_SUBMIT_TIME_MS = 3000;

  /* ── Form protection ── */

  function protectForm(wrapper) {
    var form = wrapper.tagName === 'FORM' ? wrapper : wrapper.querySelector('form');
    if (!form) return;

    /* Prevent double-init */
    if (form.hasAttribute('data-tc-secured')) return;
    form.setAttribute('data-tc-secured', 'true');

    var renderTime = Date.now();

    /* 1. Inject honeypot field */
    var honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = 'tc_website';
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    honeypot.setAttribute('aria-hidden', 'true');
    honeypot.style.cssText = 'position:absolute;left:-9999px;height:0;width:0;overflow:hidden;opacity:0;pointer-events:none;';
    form.insertBefore(honeypot, form.firstChild);

    /* 2. Inject timestamp field */
    var tsField = document.createElement('input');
    tsField.type = 'hidden';
    tsField.name = 'tc_form_ts';
    tsField.value = renderTime.toString(36);
    form.appendChild(tsField);

    /* 3. Inject JS challenge token */
    var tokenField = document.createElement('input');
    tokenField.type = 'hidden';
    tokenField.name = 'tc_js_token';
    tokenField.value = btoa(Date.now().toString(36) + '_tc');
    form.appendChild(tokenField);

    /* 4. Submit handler (capture phase — runs before other handlers) */
    form.addEventListener('submit', function (e) {
      /* Honeypot check */
      if (honeypot.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showFakeSuccess(form);
        return;
      }

      /* Timing check */
      var elapsed = Date.now() - renderTime;
      if (elapsed < MIN_SUBMIT_TIME_MS) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMessage(form, 'Please wait a moment before submitting.');
      }
    }, true); /* capture: true */
  }

  function showFakeSuccess(form) {
    /* Show nothing suspicious to bots — just disable the submit button */
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Sent!';
    }
  }

  function showMessage(form, message) {
    /* Avoid duplicate messages */
    if (form.querySelector('.tc-security-msg')) return;

    var msg = document.createElement('div');
    msg.className = 'tc-security-msg';
    msg.setAttribute('role', 'alert');
    msg.style.cssText = 'background:#fef2f2;border:1px solid #fca5a5;color:#991b1b;padding:0.75rem 1rem;margin-bottom:1rem;font-size:0.875rem;';
    msg.textContent = message;

    form.insertBefore(msg, form.firstChild);

    /* Auto-remove after 5 seconds */
    setTimeout(function () {
      if (msg.parentNode) msg.parentNode.removeChild(msg);
    }, 5000);
  }

  /* ── Initialise ── */

  function init() {
    var protectedElements = document.querySelectorAll('[data-tc-protected]');
    for (var i = 0; i < protectedElements.length; i++) {
      protectForm(protectedElements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
